import { render, staticRenderFns } from "./SolutionComponent.vue?vue&type=template&id=a550a3c8&scoped=true"
import script from "./SolutionComponent.vue?vue&type=script&lang=js"
export * from "./SolutionComponent.vue?vue&type=script&lang=js"
import style0 from "./SolutionComponent.vue?vue&type=style&index=0&id=a550a3c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a550a3c8",
  null
  
)

export default component.exports